import { selectIsAutobrokerEnabled } from './selectIsAutobrokerEnabled';
import { IAppState } from '../../redux';

export function selectIsAuctionEnabled(state: IAppState): boolean {
  const { auction } = state;

  const isAutobrokerEnabled = selectIsAutobrokerEnabled(state);

  return auction.isEnabled && !isAutobrokerEnabled;
}
